















































import { Component, Vue } from 'vue-property-decorator'

import LuciaCoreGQL from '@/data/gql'
import Images from '@/data/images'

import Statistic from '@/comps/Statistic.vue'

import 'semantic-ui-css/components/image.min.css'
import 'semantic-ui-css/components/label.min.css'
import 'semantic-ui-css/components/button.min.css'
import 'semantic-ui-css/components/container.min.css'
import 'semantic-ui-css/components/placeholder.min.css'

const gql = new LuciaCoreGQL()

interface Version {
  full: string,
  codename: string
}

interface Stats {
  [index: number]: {
    name: string,
    value: number,
    icon: string,
    diff: number
  }
}

interface CountGQLResponse {
  count: number
}

interface LandingGQLStats {
  commandCount: number,
  guildCount: number,
  memberCount: number,
  messageCount: CountGQLResponse[],
  impersonateCount: CountGQLResponse[]
}

interface LandingGQLResponse {
  sigma: {
    stats: LandingGQLStats,
    info: {
      beta: boolean,
      buildDate: number,
      codename: string,
      version: {
        major: number,
        minor: number,
        patch: number
      }
    }
  }
}

function updateLanding (ctx: SigmaLanding, noLoad: boolean) {
  const qry = `{
      sigma {
        stats {
          commandCount
          guildCount
          memberCount
          messageCount: events(only: ["message"]) {
            count
          },
          impersonateCount: commands(only: ["impersonate"]) {
            count
          }
        }
        info {
          beta
          buildDate
          codename
          version {
            major
            minor
            patch
          }
        }
      }
    }`
  ctx.loading = !noLoad
  ctx.refreshing = true
  const req: Promise<LandingGQLResponse> = gql.request(qry)
  req.then((data: LandingGQLResponse) => {
    const dv = data.sigma.info
    ctx.version = {
      full: [
        dv.version.major,
        dv.version.minor,
        dv.version.patch
      ].join('.'),
      codename: dv.codename
    } as Version
    ctx.loading = !noLoad
    ctx.refreshing = true
    const ds = data.sigma.stats
    ctx.stats = [
      {
        name: 'Active Servers',
        value: ds.guildCount,
        icon: 'server',
        diff: ctx.oldStats ? ds.guildCount - ctx.oldStats.guildCount : 0
      },
      {
        name: 'Active Users',
        value: ds.memberCount,
        icon: 'user',
        diff: ctx.oldStats ? ds.memberCount - ctx.oldStats.memberCount : 0
      },
      {
        name: 'Commands Used',
        value: ds.commandCount,
        icon: 'terminal',
        diff: ctx.oldStats ? ds.commandCount - ctx.oldStats.commandCount : 0
      },
      {
        name: 'Messages Processed',
        value: ds.messageCount[0].count,
        icon: 'comment',
        diff: ctx.oldStats ? ds.messageCount[0].count - ctx.oldStats.messageCount[0].count : 0
      },
      {
        name: 'Impersonations',
        value: ds.impersonateCount[0].count,
        icon: 'qrcode',
        diff: ctx.oldStats ? ds.impersonateCount[0].count - ctx.oldStats.impersonateCount[0].count : 0
      }
    ]
    ctx.oldStats = ds
    ctx.loading = false
    ctx.refreshing = false
  })
  req.catch(() => {
    ctx.loading = false
    ctx.refreshing = false
    ctx.errored = true
  })
}

@Component({ components: { Statistic } })
export default class SigmaLanding extends Vue {
  loading = true
  refreshing = true
  refreshInterval: number|undefined
  errored = false
  imgs = Images
  version: Version = { full: '?.?.?', codename: '?????' }
  stats: Stats = []
  oldStats: LandingGQLStats|null = null;
  autoRefresh: boolean = localStorage.getItem('autoRefresh') === 'true'

  mounted () {
    updateLanding(this, false)
    const ctx = this
    if (this.autoRefresh) {
      this.refreshInterval = setInterval(() => {
        updateLanding(ctx, true)
      }, 10000)
    }
  }

  refresh () {
    updateLanding(this, true)
  }

  toggleRefresh () {
    if (this.autoRefresh) {
      this.autoRefresh = false
      clearInterval(this.refreshInterval)
      localStorage.setItem('autoRefresh', 'false')
    } else {
      const ctx = this
      this.autoRefresh = true
      this.refreshInterval = setInterval(() => {
        updateLanding(ctx, true)
      }, 10000)
      localStorage.setItem('autoRefresh', 'true')
    }
  }
}
